import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {Subscription} from "rxjs";
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UsuarioBasculaGaritaService} from '../../services/usuario-bascula-garita.service';
import {MantenimientoBasculaService} from '../../services/mantenimiento-bascula.service';
import {MantenimientoGaritasService} from '../../services/mantenimiento-garitas.service';
import {IGaritaResponse} from '../../modelos/IMantGarita';
import {IMantBascula} from '../../modelos/IMantBascula';
import {UsuariosService} from '../../services/usuarios.service';
import {IUsuarioAll} from '../../modelos/IUsuario.js';
import {ParametrizarValorFleteService} from '../../services/parametrizar-valor-flete.service';
import {ParametrizacionesDeCalidadRecibidaService} from '../../services/parametrizaciones-de-calidad-recibida.service';
import { ProveedorService } from '../../services/proveedor.service';

@Component({
  selector: 'app-parametrizaciones-de-calidad-recibida',
  templateUrl: './parametrizaciones-de-calidad-recibida.component.html',
  styleUrls: ['./parametrizaciones-de-calidad-recibida.component.css']

})
export class ParametrizacionesDeCalidadRecibidaComponent implements OnInit {

  public DAT_TITULOS: any = moduloGaritas.titulos.parametrizacionesDeCalidadRecibida;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public garitaSelect: IGaritaResponse[] = [];
  public basculaSelect: IMantBascula[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;
  public showUsers: boolean = false;
  public proveedorInvalido = true;

  public agregarForm = new FormGroup({
    id: new FormControl(null),
    tipo: new FormControl(null, [Validators.required]),
    proveedor: new FormControl('', []),
    fechaIni: new FormControl('', Validators.required),
    fechaFin: new FormControl('', []),
    acidezBase: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,2})?$/)]),
    valorMin: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,2})?$/)]),
    valorMax: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,2})?$/)]),
    incremento: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,2})?$/)]),
    despro: new FormControl('', []),
  });

  public cmbUsuarios: IUsuarioAll[] = [];
  proveedor = "";
  public dateValidate = false;
  public dateValidateData;
  public dateNotLessCurrent = false;
  private subscription = new Subscription();

  constructor(
    private _util: UtilsService,
    private usuarioBasculaGaritaS: UsuarioBasculaGaritaService,
    private basculaService: MantenimientoBasculaService,
    private garitasService: MantenimientoGaritasService,
    private usuariosService: UsuariosService,
    private proveedorS: ProveedorService,
    private parametrizarValorFleteService: ParametrizarValorFleteService,
    private ParametrizacionesDeCalidadRecibidaService: ParametrizacionesDeCalidadRecibidaService
  ) {
  }

  get proveeControl() {
    return this.agregarForm.get('proveedor');
  }

  ngOnInit() {
    this.girdComponent();
    this.obtenerTodo();
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'id',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Tipo',
        field: 'tipo',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Proveedor',
        field: 'proveedor',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Fecha Inicio',
        field: 'fechaIni',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Fecha Fin',
        field: 'fechaFin',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 80,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
    ];
  }

  obtenerTodo() {
    this.loading = true;
    this.subscription.add(
      this.ParametrizacionesDeCalidadRecibidaService.obtener()
        .subscribe(
          (resp) => {
            resp.map(item => {
              item["fechaIni"] = item["fechaIni"].split("T")[0];
              item["fechaFin"] = (item["fechaFin"] == null) ? "" : item["fechaFin"].split("T")[0];
              return item;
            })
            this.rowData = resp;
            this.loading = false;
          },
          (error) => {
            this.rowData = [];
            this.loading = false;
          }
        )
    );
  }

  guardarCrearNueva() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    console.log("data", data)

    data.fechaIni = data.fechaIni + "T00:00:00";
    data.fechaFin = (data.fechaFin == null) ? "" : data.fechaFin + "T00:00:00";

    data.proveedor = data.proveedor == null ? 0: data.proveedor.trim();

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        // text: `Usuario: ${data.idusuario} ${data.bascula?`- Báscula: ${data.bascula}`: ``} ${data.garita?`- Garita: ${data.garita}`: ``}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.ParametrizacionesDeCalidadRecibidaService.crear(data),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarEditar() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    data.fechaIni = data.fechaIni + "T00:00:00";
    data.fechaFin = (data.fechaFin == null) ? "" : data.fechaFin + "T00:00:00";

    data.proveedor = data.proveedor.trim();

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        // text: `Usuario: ${data.idusuario} ${data.bascula?`- Báscula: ${data.bascula}`: ``} ${data.garita?`- Garita: ${data.garita}`: ``}`,
        action: this.DAT_BTNS.editar,
        funcion: this.ParametrizacionesDeCalidadRecibidaService.editar(data),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  eliminar({rowData}) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `Usuario: ${rowData.idusuario} ${rowData.bascula?`- Báscula: ${rowData.bascula}`: ``} ${rowData.garita?`- Garita: ${rowData.garita}`: ``}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.ParametrizacionesDeCalidadRecibidaService.eliminar(rowData.id),
      })
      .then((res: any) => {
        this.obtenerTodo();
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  nuevo() {

    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.agregarForm.reset();
    this.agregarForm.get('id').disable({onlySelf: true});
    this.agregarForm.get('fechaIni').enable();

    this.agregarForm.get('id').disable({onlySelf: true});
    this.agregarForm.get('tipo').enable({onlySelf: true});
    this.agregarForm.get('valorMin').enable({onlySelf: true});
    this.agregarForm.get('valorMax').enable({onlySelf: true});
    this.agregarForm.get('proveedor').enable({onlySelf: true});
    this.agregarForm.get('acidezBase').enable({onlySelf: true});
    this.agregarForm.get('incremento').enable({onlySelf: true});

    this.openModal();

  }

  editar({rowData}) {

    rowData.fechaIni = (rowData.fechaIni).split("T")[0];
    rowData.fechaFin = (rowData.fechaFin).split("T")[0];

    this.isCreate = false;
    this.agregarForm.patchValue(rowData);
    this.agregarForm.get('fechaIni').disable();
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;

    if(rowData.tipo == "Acidez") this.agregarForm.get("tipo").setValue(0)
    if(rowData.tipo == "Humedad_Impureza") this.agregarForm.get("tipo").setValue(1)

    this.agregarForm.get('id').disable({onlySelf: true});
    this.agregarForm.get('tipo').disable({onlySelf: true});
    this.agregarForm.get('valorMin').disable({onlySelf: true});
    this.agregarForm.get('valorMax').disable({onlySelf: true});
    this.agregarForm.get('proveedor').disable({onlySelf: true});
    this.agregarForm.get('incremento').disable({onlySelf: true});

    this.openModal();
    this.onChangeProveedor("");

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
    if (!this.isCreate) this.guardarEditar();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getDescProveedor(proveedor: string): any {
    console.log("proveedor", proveedor)
    let prov = "";
    if (this.proveeControl.value > 0) {
      this.parametrizarValorFleteService.getProveedor(proveedor).subscribe(
        (resp) => {
          if (resp) prov = resp.provNombre;
          prov = '';
        },
        (error) => {
          prov = '';
        }
      );
      return prov;
    }
  }

  onChangeProveedor(event: any) {
    console.log("onChangeProveedor", this.proveeControl.value)
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    this.agregarForm.get("proveedor").setValue(this.agregarForm.get("proveedor").value.trim())
    if (this.proveeControl.value != null && this.proveeControl.value.length > 0) {
      this.proveedorS.obtenerPorId(this.proveeControl.value.trim()).subscribe(
        (resp) => {
          if (resp) {
            this.proveedorInvalido = false;
            this.agregarForm.controls['despro'].setValue(resp.idProveedor + " - " + resp.nombre);
          } else {
            this.proveedorInvalido = true;
            this.agregarForm.controls['despro'].setValue('');
          }
          this.onChangeValues();
          this.loading = false;
        },
        (error) => {
          this.onChangeValues();
          this.loading = false;
          this.proveedorInvalido = true;
          this.agregarForm.controls['despro'].setValue('');
        }
      );
    }
  }

  noWhitespace(event: KeyboardEvent) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32)
      return false;

    return true;
  }

  onChangeValues() {

  }

  validateRangeDates() {

    let day;
    let month;
    let year;
    let dateStart;
    let dateEnd;
    let dateSplit;
    let datesToValidate = [];
    let datesRange = [];

    dateStart = this.agregarForm.controls['fechaIni'].value;
    dateEnd = this.agregarForm.controls['fechaFin'].value;
    dateSplit = dateStart.split("-");

    day = parseInt(dateSplit[2]);
    month = parseInt(dateSplit[1]);
    year = parseInt(dateSplit[0]);

    while (dateStart <= dateEnd) {

      datesRange.push(dateStart);
      day = day + 1;

      if (day >= 31) {
        day = 1;
        month = month + 1;
      }
      if (month >= 13) {
        month = 1;
        year = year + 1;
      }

      dateStart = year.toString().padStart(2, "0") + "-" + month.toString().padStart(2, "0") + "-" + day.toString().padStart(2, "0");

    }

    for (let i = 0; i < this.rowData.length; i++) {

      if (this.rowData[i].id == this.agregarForm.controls['id'].value) continue;

      dateStart = this.rowData[i].fechaIni.split("T")[0].split("-").reverse().join('-');
      dateEnd = this.rowData[i].fechaFin.split("T")[0].split("-").reverse().join('-');
      dateSplit = dateStart.split("-");

      day = parseInt(dateSplit[2]);
      month = parseInt(dateSplit[1]);
      year = parseInt(dateSplit[0]);

      while (dateStart <= dateEnd) {

        console.log("WHILE", dateStart, "<=", dateEnd)

        datesToValidate.push(dateStart + "|" + this.rowData[i].id);

        day = day + 1;

        if (day >= 31) {
          day = 1;
          month = month + 1;
        }
        if (month >= 13) {
          month = 1;
          year = year + 1;
        }

        dateStart = year.toString().padStart(2, "0") + "-" + month.toString().padStart(2, "0") + "-" + day.toString().padStart(2, "0");

      }
    }

    for (let i = 0; i < datesRange.length; i++) {
      if (datesToValidate.find((x => x.split("|")[0] === datesRange[i]))) {
        this.dateValidateData = this.rowData.find(x => x.id == datesToValidate.find((element) => {
          if (element.split("|")[0] === datesRange[i]) {
            return element.split("|")[1];
          }
        }).split("|")[1]);

        if (
          this.agregarForm.controls['provee'].value == this.dateValidateData.provee &&
          this.agregarForm.controls['codori'].value == this.dateValidateData.codori &&
          this.agregarForm.controls['mat'].value == this.dateValidateData.mat
        ) {
          this.dateValidate = true;
          break;
        } else
          ;

      }
    }

  }

  onChangeTipo() {
    // if (this.agregarForm.controls['tipo'].value == 1) {
    //   this.agregarForm.controls['acidezBase'].disable();
    // } else {
    //   this.agregarForm.controls['acidezBase'].enable();
    // }
  }

  onChangeDates() {
    console.log("onChangeValues")
    this.dateValidate = false;
    this.dateNotLessCurrent = false;

    if (this.agregarForm.controls['fechaFin'].value.length > 0 && this.agregarForm.controls['fechaFin'].value.length > 0) {
      if (this.agregarForm.controls['fechaFin'].value < this.agregarForm.controls['fechaIni'].value) {
        this.dateNotLessCurrent = true;
      } else {
        this.dateNotLessCurrent = false;
      }
    }

    if (!this.dateNotLessCurrent) {
      this.validateRangeDates()
    }

  }

  keyDecimals(event: KeyboardEvent, input: string) {
    var charCode = (event.which) ? event.which : event.keyCode;
    console.log("charCode", charCode)
    if (charCode != 110 && charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57)) {
      this.agregarForm.get(input).setValue(this.agregarForm.get(input).value.slice(0, -1));
      return false;
    }

    return true;
  }

}
